import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { AuthGuard } from '@core/guards/auth.guard';
import { BlAuthGuard } from '@core/guards/bl-auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/after-login/after-login.module').then((m) => m.AfterLoginModule),
    // canActivate: [AuthGuard],
    // change to before if session resume is not supported in your app
  },
  {
    path: 'al',
    loadChildren: () => import('./features/after-login/after-login.module').then((m) => m.AfterLoginModule),
    // canActivate: [AuthGuard],
  },
  {
    path: 'bl',
    loadChildren: () => import('./features/before-login/before-login.module').then((m) => m.BeforeLoginModule),
    // canActivate: [BlAuthGuard],
  },
  // {
  //   path: 'header',
  //   loadChildren: () => import('././header/header.module').then((m) => m.HeaderModule),
  // },

  {
    path: '**',
    redirectTo: 'al/assets', // or 404 module
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
